export const skeletonPattern = () => {
    return [
        {
            row: [25, 75],
            gap: 3,
            items: [
                {
                    type: 'circle',
                    diameter: 7
                },
                {
                    content: [
                        {
                            type: 'text',
                            width: 80,
                            align: 'right'
                        },
                        {
                            type: 'subtitle',
                            width: 80,
                            align: 'right'
                        }
                    ]
                }
            ]
        },
        {
            type: 'table',
            size: {
                rows: 1,
                columns: 2
            }
        }
    ];
};
